module.exports = __webpack_public_path__ + "img/product-shot_02.ce637eaf.jpg";